export const SideDrawerHeader = {
  DATE: 'Date : ',
  IN_TIME: 'In Time : ',
  OUT_TIME: 'Out Time : ',
};
